export const global = {
  // base_url: "https://test.takafulbruneidownloads.com",
  // base_url: "https://tbd-uat.takafulbruneidownloads.com",
  // base_url: "https://tbk-uat.takafulbruneidownloads.com",
  // base_url: "https://tbdbackend.test",
  // base_url: "https://loadbalancer.takafulbruneidownloads.com",
  base_url: "https://tbmapp-uat.takafulbruneidownloads.com",

  // base_url2: "https://lpsbackend.takafulbruneidownloads.com",
  // base_url2: "https://lpsdev.takafulbruneidownloads.com",
  // base_url2: 'https://lpsuat.takafulbruneidownloads.com',
  // base_url2: "https://lpsbackend.test",
  base_url2: "https://lpsdev1.takafulbruneidownloads.com",
  
  get url() {
    return this.base_url + "/api";
  },
  get url2() {
    return this.base_url + "/apiv2";
  },
  get lps_url() {
    return this.base_url2 + "/api";
  },

  get app_version() {
    return "6.5.0";
  }
};

export const lps = () => {
  return "Loyalty Point System";
};
